// extracted by mini-css-extract-plugin
module.exports = {"main":"Bench_main__3IcHS","players":"Bench_players__1iJCD"};